// @ts-nocheck
import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';

export interface ScoutAthlete {
  id: string;
  name: string;
  username: string;
  email: string;
  sport_id: string;
  grad_year: number;
  city: string;
  state: string;
  avatar_url: string;
}

export function useScoutAthletes() {
  const { profile } = useAuth();
  const [athletes, setAthletes] = useState<ScoutAthlete[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAthletes = async () => {
      if (!profile?.id) return;

      try {
        const { data, error: fetchError } = await supabase
          .from('scout_athlete_relationships')
          .select(`
            athlete:athlete_id (
              id,
              name,
              username,
              email,
              sport_id,
              grad_year,
              city,
              state,
              avatar_url
            )
          `)
          .eq('scout_id', profile.id);

        if (fetchError) throw fetchError;

        const formatted: ScoutAthlete[] = (data || [])
          .flatMap((r) => {
            const athlete = r.athlete;
            if (!athlete) return [];
            return Array.isArray(athlete) ? athlete : [athlete];
          });

        setAthletes(formatted);
        setError(null);
      } catch (err: any) {
        console.error('❌ useScoutAthletes:', err.message || err);
        setError(err.message || 'Unknown error');
        setAthletes([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAthletes();
  }, [profile?.id]);

  return { athletes, isLoading, error };
}
